import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Image as ImageIcon, TrendingDown, Laptop } from 'lucide-react';
export function Pain() {
  return <section className="py-12 md:py-24 bg-zinc-950 px-4 relative" data-id="element-106" data-mp="1nyq16j813y19">
      <div className="max-w-4xl mx-auto" data-id="element-107" data-mp="1j0eqy7dtnlii">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-108" data-mp="1e2mxva1fxtcq">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-109" data-mp="15ab8lri2cbyc">
            Cada Día Que Pasa Sin Este Protocolo, Tu Competencia Te Está <span className="text-red-500" data-id="element-110" data-mp="10c9px7ojuene">Robando Clientes</span> Con Anuncios Que Tú Podrías Hacer Mejor
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-111" data-mp="vdopp89aruyy">Déjame adivinar cómo se ve tu operación de anuncios hoy:</p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-112" data-mp="qeva9aag9tw5">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-6 rounded-2xl bg-zinc-900/50 border border-zinc-800 group" data-id="element-113" data-mp="mc8onr4dh57e">
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: "linear"
          }} className="inline-block mb-4" data-id="element-114" data-mp="1ozlr2xuvw1x9">
              <Clock className="w-10 h-10 text-zinc-400 drop-shadow-[0_0_8px_rgba(161,161,170,0.3)] group-hover:text-amber-500 group-hover:drop-shadow-[0_0_12px_rgba(245,158,11,0.5)] transition-colors duration-500" data-id="element-115" data-mp="2hn9862wy4af5" />
            </motion.div>
            <p className="text-zinc-300 text-lg" data-id="element-116" data-mp="28mjd51fieo2h">Le pagas a una agencia que tarda 5 días en entregarte un diseño mediocre.</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-6 rounded-2xl bg-zinc-900/50 border border-zinc-800 group" data-id="element-117" data-mp="x85se5g1yoqo">
            <motion.div animate={{
            rotate: [-5, 5, -5]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }} className="inline-block mb-4" data-id="element-118" data-mp="33vn1bhrwalef">
              <ImageIcon className="w-10 h-10 text-zinc-400 drop-shadow-[0_0_8px_rgba(161,161,170,0.3)] group-hover:text-amber-500 group-hover:drop-shadow-[0_0_12px_rgba(245,158,11,0.5)] transition-colors duration-500" data-id="element-119" data-mp="2u4k1skem6eh9" />
            </motion.div>
            <p className="text-zinc-300 text-lg" data-id="element-120" data-mp="2g62gsug3fg31">O peor: tú mismo peleas con Canva a las 2 de la mañana intentando que tu anuncio no parezca hecho por un aficionado.</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-6 rounded-2xl bg-zinc-900/50 border border-zinc-800 md:col-span-2 group" data-id="element-121" data-mp="268nzytq9cpa7">
            <motion.div animate={{
            y: [0, 8, 0],
            opacity: [0.6, 1, 0.6]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }} className="inline-block mb-4" data-id="element-122" data-mp="4eygm1hqqp5u">
              <TrendingDown className="w-10 h-10 text-red-500 drop-shadow-[0_0_12px_rgba(239,68,68,0.6)] group-hover:text-red-400 transition-colors duration-500" data-id="element-123" data-mp="lqn8ct5ghegb" />
            </motion.div>
            <p className="text-zinc-300 text-lg" data-id="element-124" data-mp="qrb0xj9c23cn">Publicas. Rezas. Y el scroll no se detiene ni un segundo en tu creativo.</p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="p-8 rounded-3xl bg-gradient-to-br from-zinc-900 to-zinc-950 border border-zinc-800 text-center relative overflow-hidden" data-id="element-125" data-mp="3u6p2j23qhz9m">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-amber-500/10 blur-2xl rounded-full" data-id="element-126" data-mp="1ee9dw6y8ut5t" />
          <Laptop className="w-12 h-12 text-amber-500 mx-auto mb-6" data-id="element-127" data-mp="1jcatghwgoacj" />
          <p className="text-xl text-white leading-relaxed mb-6" data-id="element-128" data-mp="2sc3w1sbwiyw5">
            Mientras tanto, alguien con menos experiencia que tú está lanzando 50 anuncios cinematográficos esta semana — desde su laptop, en pijama, gastando $0 en producción.
          </p>
          <div className="inline-block px-6 py-3 rounded-xl bg-zinc-950 border border-zinc-800" data-id="element-129" data-mp="2wcnrmrgttug6">
            <p className="text-amber-400 font-medium" data-id="element-130" data-mp="2wf0ftmd6h11o">La diferencia entre esa persona y tú no es talento. No es presupuesto. No es suerte.</p>
            <p className="text-white font-bold mt-2" data-id="element-131" data-mp="369shb19vs81q">Es que ellos saben exactamente qué escribir. Y tú todavía no.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}